import React from "react";
import { Routes, Route } from "react-router-dom"
import Navbar from "./components/Navbar"
import Footer from "./components/Footer"
import Home from "./pages/Home"
import About from "./pages/About"
import Contact from "./pages/Contact"
import Recruitment from './pages/Recruitment'
import Training from "./pages/Training"
import DomiciliaryCare from './pages/DomiciliaryCare'
import ChildrensServices from './pages/ChildrensServices'
import SecureTransport from './pages/SecureTransport'
import Services from "./pages/Services"

function App() {
  return (
    <div className="app-shell">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services/recruitment" element={<Recruitment />} />
        <Route path="/services/training" element={<Training />} />
        <Route path="/services/domiciliary-care" element={<DomiciliaryCare />} />
        <Route path="/services/childrens-services" element={<ChildrensServices />} />
        <Route path="/services/secure-transport" element={<SecureTransport />} />
        <Route path="/services" element={<Services />} />
      </Routes>
      <Footer />
    </div>
  )
}

export default App;